const QuestionRow = ({ questionLabel, answerValue, questionValue, questions, onQuestionChange, onAnswerChange, showAnswer, onToggleAnswer }) => (
  <>
    <div className="row user-profile-row-gap">
      <div className="col-sm-4">
        <label className="user-profile-right-label">{questionLabel}</label>
      </div>
      <div className="col-sm-5">
        <select className="form-control" value={questionValue} onChange={(e) => onQuestionChange(e.target.value)}>
          <option value="-1">Select One...</option>
          {(questions || []).map((item) => (
            <option
              key={item.ChallengePhraseId ?? item.challengePhraseId}
              value={item.ChallengePhraseId ?? item.challengePhraseId}
            >
              {item.ChallengePhrase ?? item.challengePhrase}
            </option>
          ))}
        </select>
      </div>
      <div className="col-sm-1 text-left user-profile-required">*</div>
    </div>

    <div className="row user-profile-row-gap">
      <div className="col-sm-4">
        <label className="user-profile-right-label">Answer:</label>
      </div>
      <div className="col-sm-5">
        <input
          type={showAnswer ? "text" : "password"}
          className="form-control"
          value={answerValue}
          onChange={(e) => onAnswerChange(e.target.value)}
        />
      </div>
      <div className="col-sm-1 text-left user-profile-required">*</div>
      <div className="col-sm-1 text-left user-profile-eye-wrap">
        <button type="button" className="user-profile-eye-btn" onClick={onToggleAnswer}>
          <span className="glyphicon glyphicon-eye-open" />
        </button>
      </div>
    </div>
  </>
);

const SecurityQuestionsPanel = ({
  currentPassword,
  onCurrentPasswordChange,
  currentPasswordVisible,
  onToggleCurrentPassword,
  questions,
  values,
  answerVisible,
  onQuestionValueChange,
  onAnswerValueChange,
  onToggleAnswer,
  onSubmit,
  onCancel,
}) => {
  return (
    <div id="ChangeQuestionDiv">
      <h3 className="user-profile-subheading">Change Security Question</h3>

      {/* <div className="row user-profile-row-gap">
        <div className="col-sm-4">
          <label className="user-profile-right-label">Current Password:</label>
        </div>
        <div className="col-sm-5">
          <input
            type={currentPasswordVisible ? "text" : "password"}
            className="form-control"
            value={currentPassword}
            onChange={(e) => onCurrentPasswordChange(e.target.value)}
          />
        </div>
        <div className="col-sm-1 text-left user-profile-required">*</div>
        <div className="col-sm-1 text-left user-profile-eye-wrap">
          <button type="button" className="user-profile-eye-btn" onClick={onToggleCurrentPassword}>
            <span className="glyphicon glyphicon-eye-open" />
          </button>
        </div>
      </div> */}

      <div className="user-profile-note">
        <p>Please Answer three security questions for account recovery:</p>
      </div>

      <QuestionRow
        questionLabel="Security Question 1:"
        answerValue={values.answer1}
        questionValue={values.question1}
        questions={questions}
        onQuestionChange={(value) => onQuestionValueChange("question1", value)}
        onAnswerChange={(value) => onAnswerValueChange("answer1", value)}
        showAnswer={answerVisible.answer1}
        onToggleAnswer={() => onToggleAnswer("answer1")}
      />

      <QuestionRow
        questionLabel="Security Question 2:"
        answerValue={values.answer2}
        questionValue={values.question2}
        questions={questions}
        onQuestionChange={(value) => onQuestionValueChange("question2", value)}
        onAnswerChange={(value) => onAnswerValueChange("answer2", value)}
        showAnswer={answerVisible.answer2}
        onToggleAnswer={() => onToggleAnswer("answer2")}
      />

      <QuestionRow
        questionLabel="Security Question 3:"
        answerValue={values.answer3}
        questionValue={values.question3}
        questions={questions}
        onQuestionChange={(value) => onQuestionValueChange("question3", value)}
        onAnswerChange={(value) => onAnswerValueChange("answer3", value)}
        showAnswer={answerVisible.answer3}
        onToggleAnswer={() => onToggleAnswer("answer3")}
      />

      <div className="row">
        <div className="col-sm-7">
          <button type="button" className="btn btn-primary btn_profile" onClick={onSubmit}>Submit</button>
          <button type="button" className="btn btn-primary btn_profile" onClick={onCancel}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default SecurityQuestionsPanel;
